import {IMarketingBanner} from '../../models';
import {makeAsyncReducer, composeReducers, makeReducer, StateAsyncProperty} from '../../redux-toolbelt';

import {getMarketingBanners, clearMarketingBanners} from './marketingBannersActions';

export type MarketingBannerData = {
  banners: IMarketingBanner[];
  lastFetchedAddressKey?: string;
};

export type MarketingBannerState = StateAsyncProperty<MarketingBannerData>;

const marketingBannerDefaultState: MarketingBannerState = {
  loaded: false,
  loading: true,
  data: {
    banners: [],
    lastFetchedAddressKey: undefined,
  },
};

export default composeReducers<MarketingBannerState>(
  makeReducer(clearMarketingBanners, () => marketingBannerDefaultState, {
    defaultState: marketingBannerDefaultState,
  }),
  makeAsyncReducer(getMarketingBanners),
);
